import { Box, Tag, Text, Thumbnail } from '@nimbus-ds/components';
import { RepeatIcon } from '@nimbus-ds/icons';
import { InteractiveList } from '@nimbus-ds/patterns';
import { SelectedProductInterface } from 'domains/Catalog/Products/components';
import { ProductHiddenAndWithoutStock } from 'domains/Catalog/Products/pages/components';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

interface SelectProductModalItemProps {
  product: SelectedProductInterface;
  isSelected: boolean;
  isExcluded: boolean;
  onChange: (checked: boolean) => void;
}

export function SelectProductModalItem({
  product,
  isSelected,
  isExcluded,
  onChange,
}: SelectProductModalItemProps): JSX.Element {
  const t = useTranslationCatalog();

  return (
    <InteractiveList.CheckboxItem
      title=""
      showTitle={false}
      checkbox={{
        name: product.id,
        checked: isSelected,
        disabled: isExcluded,
        onChange: ({ currentTarget }) => onChange(currentTarget.checked),
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        width="100%"
        gap="3"
      >
        <Box width="56px" height="56px" flex="0 0 56px" overflow="hidden">
          <Thumbnail
            aspectRatio="1/1"
            width="56px"
            src={product.imageUrl}
            alt={`${product.name} - ${product.id}`}
          />
        </Box>
        <Box
          flex="1"
          display="flex"
          flexDirection="column"
          gap="1"
          minWidth="0"
        >
          <Text fontWeight="regular" color="neutral-textLow" fontSize="base">
            {product.name}
          </Text>
          {isExcluded && (
            <Tag appearance="neutral">
              <RepeatIcon size="small" />
              <Text fontSize="caption">
                {t('subscriptions.form.products.inSubscription')}
              </Text>
            </Tag>
          )}
          {!isExcluded && (
            <ProductHiddenAndWithoutStock
              isVisible={product.visible}
              hasStock={product.stock}
              productId={product.id}
            />
          )}
        </Box>
      </Box>
    </InteractiveList.CheckboxItem>
  );
}
